import Web from './web';
import Mobile from './mobile';

export default {
  Web,
  Mobile,
};
